// Lightweight GA4 event helper. Safe to call before gtag loads — it just no-ops.
// Use for the purchase funnel so we can see where users drop off in GA4's Funnel Explorer.

export function trackEvent(name, params = {}) {
  try {
    if (typeof window === "undefined") return;
    if (typeof window.gtag === "function") {
      window.gtag("event", name, params);
    } else if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: name, ...params });
    }
  } catch {
    // Swallow: analytics must never break the app
  }
}

// Funnel stages (use these exact names in GA4 Funnel Explorer)
export const Events = {
  SIGNUP_COMPLETED: "signup_completed",
  LOGIN_COMPLETED: "login_completed",
  LYRICS_GENERATED: "lyrics_generated",
  SONG_GENERATED: "song_generated",
  PRICING_VIEWED: "pricing_viewed",
  CHECKOUT_OPENED: "checkout_opened",     // Razorpay modal opened
  PURCHASE_COMPLETED: "purchase",          // GA4 standard ecommerce event name
  PURCHASE_FAILED: "purchase_failed",
  GALLERY_PUBLISHED: "gallery_published",
  GALLERY_LIKED: "gallery_liked",
  GALLERY_SHARED: "gallery_shared",
};
